import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import Placeholder from 'Pods/ThreeDStudio/Shared/Placeholder/Placeholder'

import arrow from 'images/three_d_studio/remesh/arrow.webp'

function AnimateTab() {
  const t = useTranslation()

  return (
    <Placeholder
      title={t('viewerSidebar.enhance.animate.title')}
      description={t('viewerSidebar.enhance.animate.description')}
    >
      <div className="animate-tab__preview" aria-hidden="true">
        <img
          alt=""
          className="animate-tab__preview-image animate-tab__preview-image--static"
          src="/assets/three_d_studio/animated_tab/ninja.webp"
          height={179}
          width={138}
        />
        <span className="animate-tab__preview-arrow">
          <img
            src={arrow}
            alt="Arrow"
            width={27}
            height={12}
          />
        </span>
        <img
          alt=""
          className="animate-tab__preview-image animate-tab__preview-image--animated"
          src="/assets/three_d_studio/animated_tab/ninja_running.webp"
          height={164}
          width={126}
        />
      </div>
    </Placeholder>
  )
}

export default memo(AnimateTab)
